import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AssetUIModel } from '@thehubz/client/core';
import { AnyType } from '@thehubz/shared/model';
import { AssetsControlComponent } from '../assets-control/assets-control.component';

@Component({
  selector: 'thehubz-asset-custom-control',
  templateUrl: './asset-custom-control.component.html',
  styleUrls: ['./asset-custom-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AssetCustomControlComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [AssetsControlComponent],
})
export class AssetCustomControlComponent implements ControlValueAccessor {
  selectedAssets: AssetUIModel[] = [];
  @Input() editAssets?: AssetUIModel[] = [];
  @Input() selectedAssetIds?: string[] = [];
  configObject = {
    title: $localize`New assets`,
    noOfItems: 4,
    routerLink: 'assets',
    className: '',
    cardHeight: '!h-[160px]',
    callFrom: 'assetUploadStepper',
    rowHeight: '!h-[188px]',
    emitSelectedAssets: true,
    hideDelete: true,
    hideDownload: true,
    hideAddToBasket: true,
    hideListViewMenu: true,
  };

  onChanges!: ($event: AssetUIModel[]) => void;
  onTouched!: () => void;

  assetsSelected(assets: AssetUIModel[]) {
    if (assets.length) {
      this.onTouched();
    }
    this.onChanges(assets);
  }

  writeValue(assets: AssetUIModel[]): void {
    if (assets && assets.length > 0) {
      this.selectedAssets = assets;
    } else {
      if (this.editAssets && this.editAssets?.length > 0) {
        this.selectedAssets = this.editAssets;
      } else {
        this.selectedAssets = assets;
      }
    }
    if (this.selectedAssets.length > 0) {
      setTimeout(() => {
        this.assetsSelected(this.selectedAssets);
      }, 0);
    }
  }

  registerOnChange(fn: ($event: AssetUIModel[]) => void): void {
    this.onChanges = fn;
  }

  registerOnTouched(fn: AnyType): void {
    this.onTouched = fn;
  }
}
